export const inspectionReportInitialValues = {
    agrupamento: 0,
    boExibirProprietario: false,
    boExibirAcessibilidade: false,
    boExibirSituacao: false,
    boVistoriaExibirAprovados: true,
    boVistoriaExibirReprovados: true,
    boVistoriaExibirRealizar: false,
    boVistoriaExibirCertificados: false,
    boVistoriaExibirNaoCertificados: false,
    boExibirResumo: true,
    cdTipoPeriodo: 1,
    dtVistoria: { dtInicio: '', dtFim: '' },
    dtEmissao: { dtInicio: '', dtFim: '' },
    dtVencimento: { dtInicio: '', dtFim: '' },
    nuSolicitacao: '',
    usuarios: [],
    municipios: [],
    tiposEmpresa: [],
    tiposPessoaFisica: [],
    tiposVeiculo: [],
    deUtilizacao: '',
    boVeiculoAcessivel: false,
    subSistemas: [],
    resultadoVistoria: [],
    situacaoVistoria: [],
    placas: [],
};
